<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase :title="nodeTitle" icon="{ }" color="#0f766e">
        <!-- summary badges -->
        <div v-if="parsed" class="flex flex-wrap gap-1 mb-1.5">
            <span v-if="parsed.obj"
                class="px-1.5 py-0.5 rounded text-[10px] font-mono bg-teal-900 text-teal-300 border border-teal-700">
                {{ parsed.obj }}
            </span>
            <span v-if="parsed.page !== undefined"
                class="px-1.5 py-0.5 rounded text-[10px] font-mono bg-white/15 text-gray-300">
                p{{ parsed.page }}
            </span>
            <span v-if="parsed.id !== undefined"
                class="px-1.5 py-0.5 rounded text-[10px] font-mono bg-white/15 text-gray-300">
                id={{ parsed.id }}
            </span>
        </div>

        <!-- JSON payload editor -->
        <label>JSON payload</label>
        <textarea
            rows="3"
            :value="props.data.payload ?? ''"
            @input="update('payload', $event.target.value)"
            @change="update('payload', $event.target.value)"
            class="w-full font-mono resize-none leading-relaxed"
            style="background:var(--ui-bg-input);color:var(--ui-active);border:1px solid rgba(255,255,255,0.2);border-radius:4px;padding:4px;font-size:10px"
            placeholder='{"page":0,"id":1,"obj":"btn","text":"Hi"}' />

        <p v-if="parseError" class="text-red-400 text-[10px] mt-0.5">⚠ {{ parseError }}</p>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { computed } from 'vue';
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const update = (key, val) => updateNodeData(props.id, { ...props.data, [key]: val });

const parsed = computed(() => {
    try { return JSON.parse(props.data?.payload ?? ''); }
    catch { return null; }
});

const parseError = computed(() => {
    const p = (props.data?.payload ?? '').trim();
    if (!p) return null;
    try { JSON.parse(p); return null; }
    catch (e) { return 'Invalid JSON'; }
});

const nodeTitle = computed(() => {
    if (!parsed.value) return 'JSONL';
    const parts = [];
    if (parsed.value.obj) parts.push(parsed.value.obj);
    if (parsed.value.page !== undefined) parts.push(`p${parsed.value.page}`);
    if (parsed.value.id !== undefined) parts.push(`id${parsed.value.id}`);
    return parts.length ? parts.join(' · ') : 'JSONL';
});
</script>
